import { ChevronDown } from 'lucide-react';
import { useState } from 'react';
import { cn } from '../lib/cn.ts';
import type { TranscriptLine } from '../session/conversation.ts';

export function Transcript({ lines }: { lines: TranscriptLine[] }) {
  const [open, setOpen] = useState(false);
  if (lines.length === 0) return null;
  const last = lines[lines.length - 1]!;
  return (
    // Opaque: cards scroll up beneath it, and a see-through chip mixes their text with this line.
    <section className="rounded-3xl bg-bg ring-1 ring-fg/10">
      <button
        type="button"
        data-testid="transcript-toggle"
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center gap-2 px-4 py-3 text-left text-sm text-muted"
      >
        <span className="min-w-0 flex-1 truncate">
          <span className="text-subtle">{last.role === 'user' ? 'You' : 'fuse'}: </span>
          {last.text}
        </span>
        <ChevronDown className={cn('size-4 transition', open && 'rotate-180')} />
      </button>
      {open ? (
        <ol data-testid="transcript" className="max-h-72 space-y-2 overflow-y-auto px-4 pb-4 text-[15px]">
          {lines.map((l) => (
            <li key={l.id} data-role={l.role} className={cn(l.role === 'user' ? 'text-accent' : 'text-fg/80')}>
              <span className="mr-1 text-xs uppercase tracking-wide text-subtle">
                {l.role === 'user' ? 'you' : 'fuse'}
              </span>
              {l.text}
            </li>
          ))}
        </ol>
      ) : null}
    </section>
  );
}
